// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bar":"floating-bar__bar--1Ty5I","not-fixed":"floating-bar__not-fixed--DbdVt","notFixed":"floating-bar__not-fixed--DbdVt"};